<div class="relative">
  <mat-icon class="absolute left-3.5 top-1/2 -translate-y-1/2 !text-gray-400 !text-[20px] !h-5 !w-5 pointer-events-none">person_search</mat-icon>
  <input
    type="text"
    class="w-full pl-11 pr-11 py-3 rounded-xl border border-gray-200 bg-white text-sm text-gray-900 shadow-sm outline-none transition-all placeholder:text-gray-400 focus:border-amber-400 focus:ring-4 focus:ring-amber-100"
    placeholder="Search by name, email or phone number"
    autocomplete="off"
    [formControl]="myControl"
    [matAutocomplete]="auto"
  />
  <div class="absolute right-2.5 top-1/2 -translate-y-1/2 flex items-center">
    @if (loading) {
    <mat-spinner diameter="18"></mat-spinner>
    } @else if (hasText) {
    <button
      type="button"
      class="h-7 w-7 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700 flex items-center justify-center transition-colors"
      aria-label="Clear search"
      (mousedown)="$event.preventDefault()"
      (click)="clear()"
    >
      <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">close</mat-icon>
    </button>
    }
  </div>
</div>

<mat-autocomplete
  #auto="matAutocomplete"
  class="cust-panel"
  [displayWith]="displayFn"
  [autoActiveFirstOption]="true"
  [hideSingleSelectionIndicator]="true"
  (optionSelected)="onSelected($event.option.value)"
>
  @if (query.length < 2) {
  <div class="cust-empty">
    <mat-icon class="!text-[26px] !h-[26px] !w-[26px] !text-gray-300">keyboard</mat-icon>
    <div class="text-sm text-gray-500 mt-1">Type at least 2 characters</div>
    <div class="text-xs text-gray-400">You can search by name, email or phone, e.g. "john smith" or "07717"</div>
  </div>
  } @else if (loading && !items.length) {
  <div class="cust-empty">
    <mat-spinner diameter="22"></mat-spinner>
    <div class="text-sm text-gray-500 mt-2">Searching...</div>
  </div>
  } @else if (items.length) {
  <div class="cust-header">
    {{ items.length }}{{ items.length >= maxResults ? '+' : '' }} match{{ items.length === 1 ? '' : 'es' }}
    <span class="cust-hint">Use ↑ ↓ and Enter</span>
  </div>
  @for (option of items; track option.userid) {
  <mat-option [value]="option" class="cust-option">
    <div class="flex items-center gap-3 py-1.5 w-full">
      <span class="h-10 w-10 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0" [class]="avatarClass(option)">{{ initials(option) }}</span>
      <div class="min-w-0 flex-1">
        <div class="flex flex-wrap items-center gap-2">
          <span class="text-sm font-semibold text-gray-900">
            @for (seg of segments(option.firstname + ' ' + option.lastname, query); track $index) {
            <span [class]="seg.match ? 'cust-mark' : ''">{{ seg.text }}</span>
            }
          </span>
          @if (kind(option); as k) {
          <span class="text-[10px] font-bold px-2 py-0.5 rounded-full" [class]="k.cls">{{ k.label }}</span>
          }
        </div>
        <div class="mt-0.5 flex flex-wrap items-center gap-x-4 gap-y-0.5 text-xs text-gray-500">
          @if (option.useremail) {
          <span class="flex items-center gap-1 min-w-0">
            <mat-icon class="!text-[13px] !h-[13px] !w-[13px] !text-gray-400">mail</mat-icon>
            <span class="truncate">
              @for (seg of segments(option.useremail, query); track $index) {
              <span [class]="seg.match ? 'cust-mark' : ''">{{ seg.text }}</span>
              }
            </span>
          </span>
          }
          @if (option.phone) {
          <span class="flex items-center gap-1">
            <mat-icon class="!text-[13px] !h-[13px] !w-[13px] !text-gray-400">call</mat-icon>
            @for (seg of segments(option.phone, query); track $index) {
            <span [class]="seg.match ? 'cust-mark' : ''">{{ seg.text }}</span>
            }
          </span>
          }
        </div>
      </div>
      <div class="hidden sm:flex flex-col items-end gap-0.5 flex-shrink-0 text-right">
        @if (option.orderCount > 0) {
        <span class="text-xs font-semibold text-emerald-700">{{ option.orderCount }} order{{ option.orderCount === 1 ? '' : 's' }}</span>
        <span class="text-[11px] text-gray-400">last {{ option.lastOrderDate | date:'MMM yyyy' }}</span>
        } @else {
        <span class="text-xs font-semibold text-gray-400">New customer</span>
        }
        @if (option.userpoints > 0) {
        <span class="text-[11px] font-semibold text-amber-700">{{ option.userpoints | number }} points</span>
        }
      </div>
    </div>
  </mat-option>
  }
  @if (items.length >= maxResults) {
  <div class="cust-footer">Showing the first {{ maxResults }} - type more to narrow it down</div>
  }
  } @else {
  <div class="cust-empty">
    <mat-icon class="!text-[26px] !h-[26px] !w-[26px] !text-gray-300">search_off</mat-icon>
    <div class="font-semibold text-gray-700 mt-1">No customer matches "{{ query }}"</div>
    <div class="text-xs text-gray-400 mt-0.5">Check the spelling, or use Create new above</div>
  </div>
  }
</mat-autocomplete>
